import React from "react";
import { useCruise } from "../context/CruiseContext";
import { Anchor } from "lucide-react";

const Itinerary = () => {
  const { ITINERARY } = useCruise();
  return (
    <section id="itinerary" className="relative bg-[#111111] py-24">
      <div className="max-w-5xl mx-auto px-5">
        <div className="text-center mb-16">
          <p className="font-cond uppercase tracking-[0.4em] text-[#E50914] text-sm mb-3">Day By Day</p>
          <h2 className="font-display uppercase text-white text-4xl sm:text-6xl">
            The <span className="text-[#E50914]">Itinerary</span>
          </h2>
          <div className="flex justify-center mt-4">
            <span className="section-line" />
          </div>
        </div>

        <div className="relative">
          {/* vertical line */}
          <div className="absolute left-4 sm:left-1/2 top-0 bottom-0 w-px bg-white/10 -translate-x-1/2" />

          <div className="space-y-8">
            {ITINERARY.map((item, i) => (
              <div
                key={item.day}
                className={`relative flex flex-col sm:flex-row items-start gap-6 ${
                  i % 2 === 0 ? "sm:flex-row" : "sm:flex-row-reverse"
                }`}
              >
                {/* node */}
                <div className="absolute left-4 sm:left-1/2 -translate-x-1/2 z-10">
                  <span className="flex items-center justify-center w-8 h-8 rounded-full bg-[#E50914] text-white ring-4 ring-[#111111]">
                    <Anchor size={15} />
                  </span>
                </div>

                <div className={`w-full sm:w-1/2 pl-14 sm:pl-0 ${i % 2 === 0 ? "sm:pr-12 sm:text-right" : "sm:pl-12"}`}>
                  <div className="bg-[#1A1A1A] border border-white/5 hover:border-[#E50914]/50 p-6 transition-colors">
                    <div className={`flex items-center gap-3 mb-2 ${i % 2 === 0 ? "sm:justify-end" : ""}`}>
                      <span className="font-display text-[#E50914] text-2xl">{item.day}</span>
                      <span className="font-cond uppercase text-white/50 text-xs tracking-widest">{item.date}</span>
                    </div>
                    <h3 className="font-cond font-semibold uppercase text-white text-lg tracking-wide">{item.port}</h3>
                    <p className="text-[var(--hh-gold)] text-xs font-cond uppercase tracking-widest mt-1">{item.time}</p>
                    <ul className={`mt-3 flex flex-wrap gap-2 ${i % 2 === 0 ? "sm:justify-end" : ""}`}>
                      {item.events.map((e) => (
                        <li key={e} className="text-[11px] font-cond uppercase tracking-wider text-white/70 bg-[#0A0A0A] px-2.5 py-1">
                          {e}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="hidden sm:block sm:w-1/2" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Itinerary;
